import React from "react";
import SupplierService from "services/supplier";

import { connect } from "react-redux";
import { load } from "reducers/supplier";

class Supplier extends React.Component {
  supplierService = new SupplierService();

  constructor() {
    super(...arguments);
    this.load();
  }

  async load() {
    await this.supplierService
      .getAll()
      .then(({ data }) => this.props.load(data));
  }

  render() {
    return null;
  }
}

export default connect(null, { load })(Supplier);
